import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardMedia, Typography, Grid, Box } from '@mui/material'
import { getEntityImageUrl } from '../../../../api/utils'
import PeopleIcon from '@mui/icons-material/People'
import noAvatar from '../../../../assets/images/no-avatar.png'

const CommunityListItem = ({ group, selectCommunity }) => {
  // Handle both direct group objects and nested group membership objects
  const communityData = group?.group || group;

  const handleImageRenderError = (e) => {
    e.target.src = noAvatar
  }

  return (
    <div
      onClick={() => selectCommunity(group)}
      style={{ cursor: 'pointer', position: 'relative', width: '100%', height: '100%' }}
    >
      <Card
        style={{ padding: 0, borderRadius: 16, overflow: 'hidden', position: 'relative', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', transition: 'all .3s ease', height: '100%', display: 'flex', flexDirection: 'column' }}
        onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.15)'}}
        onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 4px 16px rgba(0,0,0,0.08)'}}
      >
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <CardMedia
            component="img"
            src={getEntityImageUrl(communityData, noAvatar)}
            alt="Community Image"
            onError={handleImageRenderError}
            style={{ objectFit: 'cover', width: '100%', height: 140, filter: 'brightness(.92)' }}
          />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0.0) 40%, rgba(0,0,0,0.55) 100%)' }} />
          <div style={{ position: 'absolute', top: 8, left: 8, background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(4px)', padding: '2px 10px', borderRadius: 24, fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
            <PeopleIcon style={{ fontSize: 16 }} /> {communityData?.participants || 0}
          </div>
          <Typography
            style={{ position: 'absolute', bottom: 8, left: 12, right: 12, color: '#fff', fontSize: 16, fontWeight: 700, textShadow: '0 2px 4px rgba(0,0,0,0.4)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {communityData?.name}
          </Typography>
        </div>
        <Box style={{ padding: '12px 14px 16px 14px', display: 'flex', flexDirection: 'column', gap: 8, flexGrow: 1 }}>
          <Typography
            style={{ fontSize: 13, lineHeight: 1.4, color: '#555', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: 60 }}
          >
            {communityData?.description || 'No description available.'}
          </Typography>
          <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto' }}>
            <Typography style={{ fontSize: 12, fontWeight: 500, color: '#888' }}>
              {communityData?.category || ''}
            </Typography>
          </Box>
        </Box>
      </Card>
    </div>
  )
}

CommunityListItem.propTypes = {
  group: PropTypes.object,
  selectCommunity: PropTypes.func
}

export default CommunityListItem
